import ComponentSpacer from "../../components/ComponentSpacer/ComponentSpacer"
import PrivacyPolicy from "../../components/PrivacyPolicy/PrivacyPolicy"

const Legal = () => {
  return (
    <>
      <ComponentSpacer />
      <PrivacyPolicy />
      <ComponentSpacer />
    </>
  )
}

export default Legal
